export default __webpack_public_path__ + "static/media/whatsAppWhite.c6f37764.svg";